import { XCircle, Plane } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function Cancel() {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="/logo-small.png" 
                alt="PetFlyCheck Logo" 
                className="w-12 h-12 object-contain"
              />
              <h1 className="text-2xl font-bold text-slate-900">PetFlyCheck</h1>
            </a>
          </div>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 py-24">
        <Card>
          <CardContent className="p-12 text-center">
            <XCircle className="w-20 h-20 text-slate-400 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Payment Cancelled</h2>
            <p className="text-slate-600 mb-8 leading-relaxed">
              Your payment was cancelled. No charges were made to your account.
              <br />
              Your submission has been saved and you can continue anytime.
            </p>
            <div className="flex gap-4 justify-center">
              <Button
                onClick={() => window.location.href = '/'}
                variant="outline"
                className="rounded-full px-8 py-3"
              >
                Start New Check
              </Button>
              <Button
                onClick={() => window.location.href = '/support'}
                className="bg-slate-900 text-white hover:bg-slate-800 rounded-full px-8 py-3"
              >
                Contact Support
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12 mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-sm text-slate-400">
            <p>© 2026 PetFlyCheck. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
